// extracted by mini-css-extract-plugin
export default {"menu-card":"kVFaXE","menu-card__image":"_65g_6","menu-card__content":"cW94wV","menu-card__title":"LE7WLn","menu-card__description":"rrXWHK","menu-card__cta":"eynJun"};